import { AxiosInstance } from 'axios';
import AxiosFactory from './axios-factory';
import { TBFFNames } from '../interfaces';

class AxiosService {
  protected axios: AxiosInstance;

  constructor(bffType: TBFFNames) {
    this.axios = AxiosFactory.getInstance(bffType);
  }
}

export default AxiosService;
